import { render, staticRenderFns } from "./LAlert.vue?vue&type=template&id=c0b16cf2&scoped=true"
import script from "./LAlert.vue?vue&type=script&lang=js"
export * from "./LAlert.vue?vue&type=script&lang=js"
import style0 from "./LAlert.vue?vue&type=style&index=0&id=c0b16cf2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b16cf2",
  null
  
)

export default component.exports